/**
 * Shared utility types used across multiple domain type files.
 * This file must NOT import from any domain type file (chat, session,
 * connection, media, etc.) to avoid circular dependencies.
 */

export enum ChatRoomStatus {
	Presenter = 'presenter',
	Streams = 'streams',
	Direct = 'direct',
}

export enum ChannelAuthMethod {
	EmailPassword = 'email_password',
	SSO = 'sso',
}

// Can use instead of `{ [key: string]: Type }`
export type StringIndexObject<T> = {
    [key: string]: T
}
